import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "@/components";
import { useMemo } from "react";

const GetInTouchFiledSection = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  handleTextEditorInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeLang === "en";
  }, [activeLang]);

  const getSelectedImageId = (keyName, id) => {
    if (id) {
      onChangeImage(keyName, id);
    } else {
      onChangeImage(keyName, "");
    }
  };

  return (
    <>
      {/* Image 1 */}
      {isHideInOtherLanguages && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText="Image"
          fieldId="home-section-12-get-in-touch-image"
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={(id) =>
            getSelectedImageId("home-section-12-get-in-touch-image", id)
          }
          selectedFileId={
            stateDetails?.["home-section-12-get-in-touch-image"] || ""
          }
          adminRole={adminRole}
          permissionsList={permissionsList}
          extraContainerClasses="mb-5"
        />
      )}

      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-12-get-in-touch-heading"
        fieldName="home-section-12-get-in-touch-heading"
        placeholderText="Heading"
        inputValue={
          stateDetails?.["home-section-12-get-in-touch-heading"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Description"
        fieldId="home-section-12-get-in-touch-description"
        fieldName="home-section-12-get-in-touch-description"
        placeholderText="Description"
        inputValue={
          stateDetails?.["home-section-12-get-in-touch-description"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* Button Label */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Button Label"
        fieldId="home-section-12-get-in-touch-button-label"
        fieldName="home-section-12-get-in-touch-button-label"
        placeholderText="Label Name"
        inputValue={
          stateDetails?.["home-section-12-get-in-touch-button-label"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />
    </>
  );
};

export default GetInTouchFiledSection;
